import { atom } from "jotai";

interface NotificationPopoverAtomInterface {
    showOnlyUnreadNotifications: boolean;
}

const INITIAL_NOTIFICATION_POPOVER_ATOM_VALUE = {
    showOnlyUnreadNotifications: true,
};

export const notificationPopoverAtom = atom(
    INITIAL_NOTIFICATION_POPOVER_ATOM_VALUE
);

export const setShowOnlyUnreadNotifications = (set: Function, value: boolean) => {
    set((prevState: NotificationPopoverAtomInterface) => {
        const newState = { ...prevState };

        newState.showOnlyUnreadNotifications = value;

        return newState;
    });
};
